import { render, staticRenderFns } from "./GroupUsers.vue?vue&type=template&id=8d3c6e36&"
import script from "./GroupUsers.vue?vue&type=script&lang=js&"
export * from "./GroupUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports